function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentNoCreditCardFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.742 30h2.523l-2.308-3h.98c1.1 0 2-.9 2-2v-9h-2v9h-2.518l-8.462-11h12.98V7c0-1.1-.9-2-2-2H10.034L7.727 2H5.204l21.538 28zM11.572 7l2.309 3h14.055V7H11.573z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.427 25l1.538 2H3.937c-1.1 0-2-.9-2-2v-9h2v9h16.49zM11.966 14l-3.077-4H3.937V7H6.58L5.043 5H3.937c-1.1 0-2 .9-2 2v7h10.029z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.437 23a1.5 1.5 0 10-.002-3.001A1.5 1.5 0 007.437 23zM13.937 21.5a1.5 1.5 0 10-3.002.001 1.5 1.5 0 003.002-.001z",
    fill: props.color
  }));
}

export default SvgIconPaymentNoCreditCardFilled;